import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../api/client";
import { useContext, useEffect } from "react";
import stateContext from "../../Context/StateContext";

export const AttachmentSize = () => {
    const globalState = useContext(stateContext);

    const attachmentSizes = useQuery({
        queryKey: ["font-sizes"],
        queryFn: () => apiClient.get("/font-sizes"),
    });

    useEffect(() => {
        if (!attachmentSizes?.data?.data) return;

        // Filter only Diamond and Zircon (case-insensitive)
        const filtered = attachmentSizes.data.data.filter((item) => {
            const t = (item.fontType || "").toString().toLowerCase();
            return t === "diamond" || t === "zircon";
        });

        // Extract sizes and add imgUrl for each
        const result = filtered.map((item) => {
            const t = (item.fontType || "").toString().toLowerCase();
            const imgUrl =
                t === "diamond"
                    ? "/assets/images/diamond.png"
                    : t === "zircon"
                    ? "/assets/images/zircon.png"
                    : "";

            return {
                fontType: item.fontType,
                sizes: item.sizeType?.sizes || {},
                imgUrl,
            };
        });

        globalState.setAttachmentPricing(result);
    }, [attachmentSizes.data?.data]);

    return null;
};
